import {Vue, Component, Watch} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

const userAgent = namespace('userAgent')

/**
 * 컴포넌트 내 모든 input focus, blur 시 footerFixed를 바꿔줌
 * @mixin
 */
@Component
export default class FooterFixedHandler extends Vue {
  @userAgent.Getter('isMobile') isMobile: boolean

  footerFixed: boolean = true

  @Watch('footerFixed')
  __footerFixed(value) {
    this.$emit('set-footer-fixed', value)
  }

  mounted() {
    this.setInputsHandler()
  }

  setInputsHandler() {
    if(this.isMobile) {
      this.$nextTick(() => {
        const inputs = this.$el.querySelectorAll('input')
        inputs.forEach((e) => {
          e.addEventListener('focus', () => {
            this.footerFixed = false
          })
          e.addEventListener('blur', () => {
            this.footerFixed = true
          })
        })
      })
    }
  }

  setFooterFixed(value) {
    this.footerFixed = value
  }
}
